module.exports = __webpack_public_path__ + "37479536fc4efb20f7ca236a90364399.png";